import { ILogisticsOptionNote } from '@nkr/models/index';

export interface IOption {
    index: number,

    kidneyPickupDateTime: string,
    kidneyPickupDateTimeValid: boolean,
    kidneyPickupDateTimeBackup: string,
    kidneyPickupDateTimeBackupValid: boolean,
    kidneyPickupDateTimeTz: string,

    flightRouteOrGround: string,
    flightRouteOrGroundValid: boolean,
    flightRouteOrGroundBackup: string,
    flightRouteOrGroundBackupValid: boolean,

    kidneyArrivalDateTime: string,
    kidneyArrivalDateTimeValid: boolean,
    kidneyArrivalDateTimeBackup: string,
    kidneyArrivalDateTimeBackupValid: boolean,
    kidneyArrivalDateTimeTz: string,

    transportMethod: string,
    transportMethodValid: boolean,
    transportMethodBackup: string,
    transportMethodBackupValid: boolean,

    transportCost: string,
    transportCostValid: boolean,
    transportCostBackup: string,
    transportCostBackupValid: boolean,

    flightCarrierAndNumber: string,
    flightCarrierAndNumberValid: boolean,
    flightCarrierAndNumberBackup: string,
    flightCarrierAndNumberBackupValid: boolean,

    flightDepartureTime: string,
    flightDepartureTimeTz: string,
    flightDepartureTimeValid: boolean,
    flightDepartureTimeBackup: string,
    flightDepartureTimeBackupTz: string,
    flightDepartureTimeBackupValid: boolean,

    flightArrivalTime: string,
    flightArrivalTimeTz: string,
    flightArrivalTimeValid: boolean,
    flightArrivalTimeBackup: string,
    flightArrivalTimeBackupTz: string,
    flightArrivalTimeBackupValid: boolean,

    leg2DepartureTime: string,
    leg2DepartureTimeTz: string,
    leg2DepartureTimeValid: boolean,
    leg2DepartureTimeBackup: string,
    leg2DepartureTimeBackupTz: string,
    leg2DepartureTimeBackupValid: boolean,

    leg2ArrivalTime: string,
    leg2ArrivalTimeTz: string,
    leg2ArrivalTimeValid: boolean,
    leg2ArrivalTimeBackup: string,
    leg2ArrivalTimeBackupTz: string,
    leg2ArrivalTimeBackupValid: boolean,

    upCharge: string,
    upChargeValid: boolean,
    upChargeBackup: string
    upChargeBackupValid: boolean,

    valid: boolean,
    missingPrimary: boolean,
    missingBackup: boolean,
    requiredOption: boolean,

    leg1BeforePickup: boolean,
    leg1ArrivalBeforeDeparture: boolean,
    leg1FlightsNotPaired: boolean
    leg1ArrivalTooLate:boolean,
    leg2BeforeLeg1: boolean,
    leg2ArrivalBeforeDeparture: boolean,
    leg2FlightsNotPaired: boolean,
    leg2ArrivalTooLate:boolean,

    leg1BeforePickupBackup: boolean,
    leg1ArrivalBeforeDepartureBackup: boolean,
    leg1FlightsNotPairedBackup: boolean
    leg1ArrivalTooLateBackup:boolean,
    leg2BeforeLeg1Backup: boolean,
    leg2ArrivalBeforeDepartureBackup: boolean,
    leg2FlightsNotPairedBackup: boolean
    leg2ArrivalTooLateBackup:boolean,

    kidneyPickUpBeforeNow: boolean,
    arrivalPickUpOutOfRange: boolean,

    leg1FlightDepartureAfterArrival: boolean,

    leg1FlightArrivalAfterArrival: boolean,

    leg2DepartureBeforeLeg1: boolean,
    leg2DepatureBeforeLeg1Arrival: boolean,
    leg2DepatureAfterArival: boolean,

    leg2ArrivalBeforeLeg1: boolean,
    leg2ArrivalBeforeArrival: boolean,

    needKidneyDepartureArrival: boolean,

    backupKidneyPickUpBeforeNow: boolean,
    backupArrivalPickUpOutOfRange: boolean,

    backupFlightDepartureAfterArrival: boolean,

    backupLeg1ArrivalBeforeDeparture: boolean,
    backupLeg1FlightArrivalAfterArrival: boolean,

    backupLeg2DepartureBeforeLeg1: boolean,
    backupLeg2DepatureBeforeLeg1Arrival: boolean,
    backupLeg2DepatureAfterArival: boolean,

    backupLeg2ArrivalBeforeLeg1: boolean,

    backupLeg2ArrivalAfterArrival: boolean,

    backupNeedKidneyDepartureArrival: boolean,

    flightArrivalMissing: boolean,
    leg2ArrivalMissing: boolean,

    flightArrivalBackupMissing: boolean,
    leg2ArrivalBackupMissing: boolean,

    flightDepartureTimeTzMissing: boolean,
    flightArrivalTimeTzMissing: boolean,
    leg2DepartureTimeTzMissing: boolean,
    leg2ArrivalTimeTzMissing: boolean,

    backupflightDepartureTimeTzMissing: boolean,
    backupflightArrivalTimeTzMissing: boolean,
    backupleg2DepartureTimeTzMissing: boolean,
    backupleg2ArrivalTimeTzMissing: boolean,
}

export interface ILogisticsOptionState {
    logisticsProvider: string,
    jobNumber: string,
    deadline: string,
    deadlineValid: boolean,
    notes: ILogisticsOptionNote[],
    options: IOption[]
}